"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _Control = _interopRequireDefault(require("@icare/rhythm-form-react/lib/elements/Control"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The PickList pure component, a component for creating searchable
 * dropdowns that a user can select values from
 */
var PickList = function PickList(_ref) {
  var id = _ref.id,
      autoLoad = _ref.autoLoad,
      clearable = _ref.clearable,
      disabled = _ref.disabled,
      error = _ref.error,
      filterFunc = _ref.filterFunc,
      helpText = _ref.helpText,
      hideDropdown = _ref.hideDropdown,
      isAsync = _ref.isAsync,
      isLoading = _ref.isLoading,
      label = _ref.label,
      listOptions = _ref.listOptions,
      name = _ref.name,
      noResultsText = _ref.noResultsText,
      onInputChange = _ref.onInputChange,
      onResultSelect = _ref.onResultSelect,
      onInputFocus = _ref.onInputFocus,
      onInputBlur = _ref.onInputBlur,
      onToggleAddressForm = _ref.onToggleAddressForm,
      optionLoaderFunc = _ref.optionLoaderFunc,
      placeholder = _ref.placeholder,
      inlinePlaceholder = _ref.inlinePlaceholder,
      required = _ref.required,
      resetInput = _ref.resetInput,
      status = _ref.status,
      statusMessage = _ref.statusMessage,
      tabSelectsValue = _ref.tabSelectsValue,
      tooltip = _ref.tooltip,
      menuRenderer = _ref.menuRenderer,
      optionRenderer = _ref.optionRenderer,
      value = _ref.value,
      width = _ref.width,
      searchPromptText = _ref.searchPromptText,
      openOnClick = _ref.openOnClick,
      clearButtonRenderer = _ref.clearButtonRenderer,
      disableManualForm = _ref.disableManualForm,
      disableAddressSearchText = _ref.disableAddressSearchText;
  var _status = status;
  var _statusMessage = statusMessage;

  if (error) {
    _status = 'error';
    _statusMessage = error;
  }

  var SelectComponent = isAsync ? _reactSelect.Async : _reactSelect.default;
  var classes = (0, _classnames.default)({
    'pick-list': true,
    'hide-dropdown': hideDropdown
  });
  var optionalProps = {};

  if (menuRenderer) {
    optionalProps.menuRenderer = menuRenderer;
  }

  if (optionRenderer) {
    optionalProps.optionRenderer = optionRenderer;
  }

  if (searchPromptText) {
    optionalProps.searchPromptText = searchPromptText;
  }

  if (clearButtonRenderer) {
    optionalProps.clearRenderer = clearButtonRenderer;
  } // TODO: Seems no aria-invalid attribute available, need to investigate it


  return /*#__PURE__*/_react.default.createElement(_Control.default, {
    className: classes,
    helpText: helpText,
    label: label,
    name: id || name,
    placeholder: placeholder,
    required: required,
    status: _status,
    statusMessage: _statusMessage,
    tooltip: tooltip,
    width: width
  }, !disableAddressSearchText && /*#__PURE__*/_react.default.createElement("p", {
    className: "address-text"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Type to search"), !disableManualForm && /*#__PURE__*/_react.default.createElement("span", null, ' ', "or", /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    role: "button",
    onClick: onToggleAddressForm
  }, ' ', "enter it manually"))), /*#__PURE__*/_react.default.createElement(SelectComponent, _extends({
    "aria-describedby": _statusMessage,
    "aria-labelledby": id,
    autoload: autoLoad,
    clearable: clearable,
    filterOptions: filterFunc,
    isLoading: isLoading,
    loadOptions: optionLoaderFunc,
    name: name,
    noResultsText: noResultsText,
    onBlurResetsInput: resetInput,
    onChange: onResultSelect,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    onCloseResetsInput: resetInput,
    onInputChange: onInputChange,
    options: listOptions,
    placeholder: inlinePlaceholder,
    required: required,
    value: value,
    disabled: disabled,
    tabSelectsValue: tabSelectsValue,
    inputRenderer: function inputRenderer(props) {
      // https://stackoverflow.com/a/38961567/574240
      return /*#__PURE__*/_react.default.createElement("input", _extends({
        autoComplete: "nope",
        id: id || name
      }, props));
    },
    openOnClick: openOnClick
  }, optionalProps)));
};

PickList.defaultProps = {
  autoLoad: false,
  clearable: false,
  disabled: false,
  error: null,
  helpText: null,
  hideDropdown: false,
  isAsync: false,
  isLoading: false,
  label: null,
  listOptions: [],
  noResultsText: 'No results found',
  onInputChange: function onInputChange() {},
  optionLoaderFunc: function optionLoaderFunc() {},
  onInputFocus: function onInputFocus() {},
  onInputBlur: function onInputBlur() {},
  onToggleAddressForm: function onToggleAddressForm() {},
  placeholder: null,
  required: false,
  inlinePlaceholder: '',
  resetInput: true,
  status: null,
  statusMessage: null,
  tooltip: null,
  tabSelectsValue: false,
  value: null,
  width: null,
  menuRenderer: null,
  optionRenderer: null,
  searchPromptText: null,
  id: null,
  openOnClick: false,
  clearButtonRenderer: null,
  disableManualForm: false,
  disableAddressSearchText: false
};
PickList.propTypes = {
  /**
   * whether an async picklist should call it's optionLoaderFunc before any input is entered
   */
  autoLoad: _propTypes.default.bool,

  /**
   * whether or not the user can clear the input text, this will render a clickable cross
   * that hides when loading and when the user has not selected anything for the first time only
   */
  clearable: _propTypes.default.bool,

  /**
   * indicates whether the input should be disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * indicates if there is an error
   */
  error: _propTypes.default.node,

  /**
   * the function used to filter options based on input
   */
  filterFunc: _propTypes.default.func.isRequired,

  /**
   * help text to be displayed below field
   */
  helpText: _propTypes.default.string,

  /**
   * hides the dropdown, even if it has results to show when true
   */
  hideDropdown: _propTypes.default.bool,

  /**
   * used to tell the picklist whether to render as an async picklist or not
   */
  isAsync: _propTypes.default.bool,

  /**
   * used to put the picklist into loading state or not
   */
  isLoading: _propTypes.default.bool,

  /**
   * field label
   */
  label: _propTypes.default.string,

  /**
   * possible options to select from, only used for non-async picklists
   */
  listOptions: _propTypes.default.array,

  /**
   * name of the input
   */
  name: _propTypes.default.string.isRequired,
  id: _propTypes.default.string,

  /**
   * text to show if no results are found
   */
  noResultsText: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),

  /**
   * called when the user types into the input
   */
  onInputChange: _propTypes.default.func,

  /**
   * called when a result is selected
   */
  onResultSelect: _propTypes.default.func.isRequired,

  /**
   * called for async picklists whenever input changes to load options
   */
  optionLoaderFunc: _propTypes.default.func,

  /**
   * placeholder text to put in field
   */
  placeholder: _propTypes.default.string,

  /**
   * whether the input is required in the form
   */
  required: _propTypes.default.bool,

  /**
   * Placeholder text to put in field
   */
  inlinePlaceholder: _propTypes.default.string,

  /**
   * whether to reset the input whenever a user blurs the field
   */
  resetInput: _propTypes.default.bool,

  /**
   * current status of input
   */
  status: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']),

  /**
   * status message to be displayed below input
   */
  statusMessage: _propTypes.default.node,

  /**
   * Indicates whether a tab press will select the currently hovered value,
   * note that this has been known to cause certain tab trap issues when set to true
   * and after clearing your input with backspace - test thoroughly if needed
   */
  tabSelectsValue: _propTypes.default.bool,

  /**
   * tooltip to be displayed to user
   */
  tooltip: _propTypes.default.string,

  /**
   * The value object containing the current value selected {value, label, ...}
   * it will initially be null
   */
  value: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  width: _propTypes.default.string,
  onInputFocus: _propTypes.default.func,
  onInputBlur: _propTypes.default.func,
  onToggleAddressForm: _propTypes.default.func,
  menuRenderer: _propTypes.default.func,
  optionRenderer: _propTypes.default.func,
  searchPromptText: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),
  openOnClick: _propTypes.default.bool,
  clearButtonRenderer: _propTypes.default.func,
  disableManualForm: _propTypes.default.bool,
  disableAddressSearchText: _propTypes.default.bool
};
var _default = PickList;
exports.default = _default;
//# sourceMappingURL=PickList.js.map